export enum ActionTypes {
  FETCH_QR_CODES = "qr-code-module/fetch-qr-codes",
  FETCH_QR_CODE = "qr-code-module/fetch-qr-code",
  FETCH_QR_CODES_FOR_CSV = "qr-code-module/fetch-qr-codes-for-csv",
  CREATE_QR_CODE = "qr-code-module/create-qr-code",
  UPDATE_QR_CODE = "qr-code-module/update-qr-code",
  DELETE_QR_CODE = "qr-code-module/remove-qr-code",
}
